// Mock data for Barbo Factory clone (frontend-only stage)

export const IMAGES = {
  logo: `${process.env.PUBLIC_URL}/barbo-logo.png`,
  banner: "https://customer-assets.emergentagent.com/job_sync-admin/artifacts/2umiua7j_download%20%289%29.webp",
  heroBg: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/zbghuxgy__PCA9972_edited.jpg",
  workshop: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/mr2ws3q6_63%20%281%29.jpg",
  detail1: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/pun892qa__PCA9965.jpg",
  detail2: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/di59ow8s_5.PNG.jpg",
  detail3: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/fugilb2l__PCA1797_1%20%281%29.jpg",
  detail4: "https://customer-assets.emergentagent.com/job_barbo-suspensions/artifacts/xi4ajt20_50.jpg",
  servicesHero: "https://images.unsplash.com/photo-1764160737085-b5682400c2e8?crop=entropy&cs=srgb&fm=jpg&q=85",
  galleryHero: "https://images.unsplash.com/photo-1656768442639-06cabcdb0805?crop=entropy&cs=srgb&fm=jpg&q=85",
  bookingHero: "https://images.unsplash.com/photo-1762012507738-cec03af3cb28?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const STATS = [
  { value: "25+", key: "stat_years" },
  { value: "1000+", key: "stat_tuned" },
  { value: "100%", key: "stat_dedication" },
];

export const HOME_SERVICES = [
  {
    id: "revisao",
    titleKey: "svc_revision_title",
    descKey: "svc_revision_desc",
    tags: ["Offroad", "Onroad", "BTT"],
  },
  {
    id: "preparacao",
    titleKey: "svc_prep_title",
    descKey: "svc_prep_desc",
    tags: ["Offroad", "Onroad", "BTT"],
  },
  {
    id: "software",
    titleKey: "svc_software_title",
    descKey: "svc_software_desc",
    tags: ["Competição", "Profissional"],
  },
];

export const SERVICES = [
  { id: 1, titleKey: "s1_title", descKey: "s1_desc", icon: "Settings" },
  { id: 2, titleKey: "s2_title", descKey: "s2_desc", icon: "Wrench" },
  { id: 3, titleKey: "s3_title", descKey: "s3_desc", icon: "LineChart" },
  { id: 4, titleKey: "s4_title", descKey: "s4_desc", icon: "Flag" },
  { id: 5, titleKey: "s5_title", descKey: "s5_desc", icon: "Bike" },
];

export const WORK_STEPS = [
  { num: "01", title: "Contact & Consultation", desc: "Get in touch with us to discuss your suspension needs and schedule a service" },
  { num: "02", title: "Technical Analysis", desc: "Complete inspection and diagnostic using professional equipment and software" },
  { num: "03", title: "Service & Setup", desc: "Professional maintenance, repair or custom setup tailored to your riding style" },
  { num: "04", title: "Testing & Delivery", desc: "Quality check and optional track testing to ensure optimal performance" },
];

export const TEAM_EXPERIENCE = [
  { id: 1, team: "Yamaha Factory MXGP", roleKey: "role_track_tech", img: IMAGES.workshop },
  { id: 2, team: "WP Factory Suspensions", roleKey: "role_suspension_spec", img: IMAGES.detail4 },
  { id: 3, team: "KTM MotoGP", roleKey: "role_track_eng", img: IMAGES.detail3 },
];

export const GALLERY = [
  { id: 1, img: IMAGES.workshop, category: "Workshop", titleKey: "g_workshop" },
  { id: 2, img: IMAGES.detail1, category: "Technical", titleKey: "g_technical" },
  { id: 3, img: IMAGES.detail2, category: "Parts", titleKey: "g_parts" },
  { id: 4, img: IMAGES.detail3, category: "Competition", titleKey: "g_competition" },
  { id: 5, img: IMAGES.detail4, category: "Technical", titleKey: "g_technical" },
  { id: 6, img: IMAGES.heroBg, category: "Competition", titleKey: "g_competition" },
  { id: 7, img: IMAGES.detail1, category: "Workshop", titleKey: "g_workshop" },
  { id: 8, img: IMAGES.detail2, category: "Parts", titleKey: "g_parts" },
];

export const GALLERY_CATEGORIES = ["All", "Competition", "Technical", "Parts", "Workshop"];

export const TESTIMONIALS = [
  { id: 1, text: "Excelente trabalho na revisão das minhas suspensões. Notei uma diferença enorme na pista!", name: "João Silva", role: "Piloto MXGP" },
  { id: 2, text: "Profissionalismo e qualidade de serviço. Recomendo a todos os pilotos.", name: "Miguel Santos", role: "Piloto Enduro" },
  { id: 3, text: "Transformaram completamente a minha bike. Suspensões como novas!", name: "Pedro Costa", role: "Entusiasta BTT" },
];

export const CONTACT = {
  address: "Travessa da Patracola n.88",
  addressFull: "Travessa da Patracola n.88, 2090-154 Alpiarça",
  phone: "+351 913 595 416",
  phoneRaw: "+351913595416",
  email: "barbofactory@gmail.com",
  hours: "Seg-Sex: 9h-18h | Sáb: 9h-13h",
};

export const VEHICLE_TYPES = ["Moto Offroad", "Moto Onroad", "BTT", "E-Bike", "Outro"];
export const SERVICE_TYPES = [
  "Revisão de Suspensões",
  "Preparação de Suspensões",
  "Motorcycle Setup Analysis",
  "Trackside Testing",
  "E-Bike Motor Service",
  "Outro",
];

// Mock bookings for the admin dashboard
export const MOCK_BOOKINGS = [
  { id: "BK-1042", name: "João Silva", email: "joao.silva@email.com", phone: "+351 912 345 678", vehicleType: "Moto Offroad", vehicleModel: "Yamaha YZ450F", serviceType: "Preparação de Suspensões", date: "2025-07-18", message: "Preparação para MXGP nacional", status: "pending", createdAt: "2025-07-09" },
  { id: "BK-1041", name: "Miguel Santos", email: "miguel.s@email.com", phone: "+351 963 111 222", vehicleType: "Moto Onroad", vehicleModel: "Honda CBR600RR", serviceType: "Revisão de Suspensões", date: "2025-07-15", message: "Revisão completa antes da época", status: "confirmed", createdAt: "2025-07-08" },
  { id: "BK-1040", name: "Pedro Costa", email: "pedro.costa@email.com", phone: "+351 934 555 777", vehicleType: "BTT", vehicleModel: "Specialized Enduro", serviceType: "Motorcycle Setup Analysis", date: "2025-07-14", message: "", status: "confirmed", createdAt: "2025-07-07" },
  { id: "BK-1039", name: "Ana Ferreira", email: "ana.f@email.com", phone: "+351 917 888 999", vehicleType: "E-Bike", vehicleModel: "Trek Rail 9", serviceType: "E-Bike Motor Service", date: "2025-07-12", message: "Motor com ruído estranho", status: "completed", createdAt: "2025-07-05" },
  { id: "BK-1038", name: "Rui Mendes", email: "rui.mendes@email.com", phone: "+351 925 333 444", vehicleType: "Moto Offroad", vehicleModel: "KTM 350 SX-F", serviceType: "Trackside Testing", date: "2025-07-11", message: "Testes de setup em pista", status: "pending", createdAt: "2025-07-04" },
  { id: "BK-1037", name: "Carlos Nunes", email: "carlos.n@email.com", phone: "+351 961 222 333", vehicleType: "Moto Onroad", vehicleModel: "Kawasaki ZX-10R", serviceType: "Revisão de Suspensões", date: "2025-07-10", message: "", status: "cancelled", createdAt: "2025-07-03" },
];

export const ADMIN_CREDENTIALS = { username: "admin", password: "barbo2024" };
